module.exports = __webpack_public_path__ + "static/media/condiciones_identidad-corporativa.58426fb1.pdf";